<template>
  <main id="admin-content">
    <Header :collapsed="false"></Header>
    <div class="body-content sessions-container">
      <div class="page-controls">
        <div class="page-controls__action-row"
              v-bind:class="{'d-none': search_show}">
          <button class="icon-button align-right" id="tooltip-target-export-csv"
                  v-if="classrooms.length" @click="csvClassrooms()">
            <download-outline-icon/>
          </button>
          <b-tooltip target="tooltip-target-export-csv" triggers="hover">
            Exportar listado de clases
          </b-tooltip>
          <download-csv v-show="false" ref="reportSessionDownload"
                  :data="report_sessions_csv" :labels="report_sessions_csv_labels" :name="'export_clases_en_directo.csv'">
          </download-csv>
        </div>
        <div class="page-controls__control-row">
          <div class="page-controls__filter"
               v-bind:class="{'d-none': search_show}">
            <div
              class="dropdown-filter select-wrapper"
            >
              <span class="dropdown-filter__select-label">Por página</span>
              <b-form-select v-on:change="resetPagination" plain class="limit-selector" v-model="classrooms_pagination.limit" :options="classrooms_pagination_options"></b-form-select>
              <span class="dropdown-filter__select-label">Filtrar por</span>
              <b-dropdown id="dropdown-right" right :text="selected_filter" variant=" dropdown-filter__select button button-select dropdown">
                <b-dropdown-item @click="nextSessions()">Todas las próximas sesiones</b-dropdown-item>
                <b-dropdown-item @click="pastSessions()">Todas las sesiones anteriores</b-dropdown-item>
                <b-dropdown-item @click="intervalSessions()">Sesiones en el intervalo</b-dropdown-item>
              </b-dropdown>
              <form
                class="date-range ng-valid ng-valid-date ng-valid-required ng-dirty ng-valid-parse ng-valid-before-start"
                v-if="selected_filter==='Sesiones en el intervalo'"
              >
                <div class="picker-input date">
                  <b-form-datepicker
                    today-button
                    label-today-button="Hoy"
                    reset-button
                    label-reset-button="Limpiar"
                    label-help="Usa las flechas del teclado para navegar entre fechas"
                    label-no-date-selected="-"
                    id="start-date" type="text"
                    v-model="filter_start_date"
                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                    locale="es"
                    @input="getClassrooms()">
                  </b-form-datepicker>
                </div>
                <div class="picker-input time">
                  <b-form-timepicker
                    label-close-button="Cerrar"
                    label-no-time-selected="-"
                    id="start-time"
                    v-model="filter_start_time"
                    locale="es"
                    @hidden="getClassrooms()">
                  </b-form-timepicker>
                </div>
                <div class="date-range__separator ng-scope">
                  hasta
                </div>
                <div class="picker-input date">
                  <b-form-datepicker
                    today-button
                    label-today-button="Hoy"
                    reset-button
                    label-reset-button="Limpiar"
                    label-help="Usa las flechas del teclado para navegar entre fechas"
                    label-no-date-selected="-"
                    id="end-date" type="text"
                    v-model="filter_end_date"
                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                    locale="es"
                    @input="getClassrooms()">
                  </b-form-datepicker>
                </div>
                <div class="picker-input time">
                  <b-form-timepicker
                    label-close-button="Cerrar"
                    label-no-time-selected="-"
                    id="end-time"
                    v-model="filter_end_time"
                    locale="es"
                    @hidden="getClassrooms()">
                  </b-form-timepicker>
                </div>
              </form>
              <b-dropdown id="dropdown-right" right :text="selected_type_filter" variant=" dropdown-filter__select button button-select dropdown">
                <b-dropdown-item @click="typeSessions('Todos los sistemas')">Todos los sistemas</b-dropdown-item>
                <b-dropdown-item @click="typeSessions('Collaborate')">Collaborate</b-dropdown-item>
                <b-dropdown-item @click="typeSessions('Adobe Connect')">Adobe Connect</b-dropdown-item>
                <b-dropdown-item @click="typeSessions('Zoom')">Zoom</b-dropdown-item>
              </b-dropdown>
              <b-dropdown id="dropdown-right" right :text="selected_status_filter" variant=" dropdown-filter__select button button-select dropdown">
                <b-dropdown-item @click="typeStatus('Todos los estados')">Todos los estados</b-dropdown-item>
                <b-dropdown-item @click="typeStatus('Eliminadas')">Eliminadas</b-dropdown-item>
                <b-dropdown-item @click="typeStatus('Activas')">Activas</b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
          <div class="page-controls__search ng-pristine ng-untouched ng-valid ng-isolate-scope ng-empty"
               v-bind:class="{'page-controls__search--opened': search_show }">
            <div class="dropdown-search" style="padding-top: 9px;">
              <button class="dropdown-search__toggle icon-button align-right " id="tooltip-target-search"
                      v-bind:class="{'d-none': search_show}"
                      @click="showSearch()">
                <magnify-icon/>
              </button>
              <b-tooltip target="tooltip-target-search" triggers="hover">
                Buscar clases en directo
              </b-tooltip>
              <div v-if="!opened_search && filter_name" style="display:inline-block;">
                <p v-text="filter_name" style="color: gray;"></p>
              </div>
              <div class="dropdown-search__dropdown"
                   v-bind:class="{'d-none': !search_show}">
                <label class="dropdown-search__icon">
                  <span>Buscar clases en directo</span>
                </label>
                <input class="dropdown-search__input ng-pristine ng-valid ng-empty ng-touched" type="text"
                       placeholder="Buscar por nombre de la clase"
                       v-model="filter_name">
                <div class="dropdown-search__controls">
                  <button class="button clear short dropdown-search__control ng-scope"
                          @click="hideSearch()">Cerrar</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="full-width-content--small" v-show="!loading">
        <div v-if="!classrooms.length" class="no-content no-results">
          <span class="no-content-title">No encontramos clases que coincidan con esos criterios.</span>
        </div>
        <table v-else class="content-table">
          <tbody>
          <tr class="content-table__header content-table__header--shadow">
            <th class="medium-8">Sala</th>
            <th class="medium-4">Hora de inicio</th>
            <th class="medium-4">Hora de finalización</th>
            <th class="medium-4">Estado</th>
          </tr>
          <tr v-for="classroom in classrooms" v-bind:key="classroom.id" v-bind:class="{'element-list-row--inactive':!classroom.status, 'element-list-row':classroom.status}">
            <td class="break-word content-table__emphasis">
              <span class="inline-column-title ng-scope">Sala:</span>
              <bdi>{{ classroom.name }}</bdi><br/>
              <span class="description" v-html="classroom.description"></span>
            </td>
            <td class="date">
              <span class="date">
                {{ classroom.start | moment("D/M/YY HH:mm") }}
              </span>
            </td>
            <td class="date">
              <span class="date">
                {{ classroom.end | moment("D/M/YY HH:mm") }}
              </span>
            </td>
            <td class="status">
              <span class="status">
                <span v-if="isOngoing(classroom)">
                  En progreso
                </span>
                <span v-if="!isOngoing(classroom)">
                  <span class="session-not-started" v-if="notYetStarted(classroom) && classroom.end">
                    Aún no ha comenzado
                  </span>
                  <span class="session-not-started" v-if="notYetStarted(classroom) && !classroom.end">
                    Aún no ha comenzado
                  </span>
                  <span class="session-not-started" v-if="hasEnded(classroom)">
                    <span class="session-ended">
                      Finalizado
                    </span>
                  </span>
                </span>
              </span>
            </td>
            <td class="item-controls">
              <b-dropdown right menu-class="button-list-icons small-icons"
                          variant=" icon-button session-row-options list-item-icon has-tooltip"
                          toggle-class="text-decoration-none" no-caret>
                <template :id="'session-options-' + classroom.id" #button-content>
                  <dots-horizontal-circle-outline-icon :size="20"/>
                  <b-tooltip :target="'session-options-' + classroom.id" triggers="hover">
                    Opciones de la sesión
                  </b-tooltip>
                </template>
                <b-dropdown-item-btn v-if="!hasEnded(classroom)" @click="enrollUserClassroom(classroom)" link-class="button">
                  <login-icon class="svg-icon small default" :size="20"/>
                  <span>Unirse a la clase</span>
                </b-dropdown-item-btn>
                <b-dropdown-item-btn link-class="button" v-b-toggle.sidebar-no-header="'sidebar-edit-' + classroom.id" @click="openRecordings(classroom)">
                  <pencil-outline-icon class="svg-icon small default" :size="20"/>
                  <span>Editar configuración</span>
                </b-dropdown-item-btn>
                <b-dropdown-item-btn link-class="button" v-b-toggle.sidebar-no-header="'sidebar-recordings-' + classroom.id" @click="openRecordings(classroom)" >
                  <video-outline-icon class="svg-icon small default" :size="20"/>
                  <span>Gestionar grabaciones</span>
                </b-dropdown-item-btn>
                <b-dropdown-item-btn @click="dispatchShowReportEvent(classroom.id); openRecordings(classroom)" link-class="button" v-b-toggle.sidebar-no-header="'sidebar-report-' + classroom.id">
                  <text-box-search-outline-icon class="svg-icon small default" :size="20"/>
                  <span>Ver informes</span>
                </b-dropdown-item-btn>
                <b-dropdown-item-btn link-class="button" @click="confirmDelete(classroom)" v-if="classroom.status">
                  <delete-outline-icon fill-color="#c23e37" class="svg-icon small default" :size="20"/>
                  <span>Eliminar sesión</span>
                </b-dropdown-item-btn>
                <b-dropdown-item-btn link-class="button" @click="confirmRecover(classroom)" v-if="!classroom.status">
                  <delete-restore-icon fill-color="#c23e37" class="svg-icon small default" :size="20"/>
                  <span>Restaurar sesión</span>
                </b-dropdown-item-btn>
              </b-dropdown>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <footer v-if="classrooms_pagination.limit < classrooms_total" class="page-footer session-list-pagination">
      <b-pagination
        v-model="classrooms_pagination_current"
        :total-rows="classrooms_total"
        :per-page="classrooms_pagination.limit"
        align="center"
        aria-controls="report-content-table"
      ></b-pagination>
    </footer>
    <ReportAdminSidebar
      :classroom="classroomReading"
      returnIconColor="#262626">
    </ReportAdminSidebar>
    <EditClassroomAdminSidebar
      :groups="user_groups"
      :classroom="classroomReading"
      @refresh="getClassrooms">
    </EditClassroomAdminSidebar>
    <SessionRecordingsSidebar
      :classroom="classroomReading">
    </SessionRecordingsSidebar>
    <vue-confirm-dialog class="pv-confirm"></vue-confirm-dialog>
  </main>
</template>

<script>
import DotsHorizontalCircleOutlineIcon from 'vue-material-design-icons/DotsHorizontalCircleOutline.vue'
import CalendarBlankOutlineIcon from 'vue-material-design-icons/CalendarBlankOutline.vue'
import LocationEnterIcon from 'vue-material-design-icons/LocationEnter.vue'
import MagnifyIcon from 'vue-material-design-icons/Magnify.vue'
import PhoneOutgoingOutlineIcon from 'vue-material-design-icons/PhoneOutgoingOutline.vue'
import LoginIcon from 'vue-material-design-icons/Login.vue'
import DeleteRestoreIcon from 'vue-material-design-icons/DeleteRestore.vue'
import TextBoxSearchOutlineIcon from 'vue-material-design-icons/TextBoxSearchOutline.vue'
import PencilOutlineIcon from 'vue-material-design-icons/PencilOutline.vue'
import DeleteOutlineIcon from 'vue-material-design-icons/DeleteOutline.vue'
import DownloadOutlineIcon from 'vue-material-design-icons/DownloadOutline.vue'
import VideoOutlineIcon from 'vue-material-design-icons/VideoOutline.vue'
import jwtMixin from '../../mixins/jwtMixin'
import utilitiesMixin from '../../mixins/utilitiesMixin'
import ReportAdminSidebar from './Modals//ReportAdminSidebar'
import EditClassroomAdminSidebar from './Modals/EditClassroomAdminSidebar'
import SessionRecordingsSidebar from './Modals/SessionRecordingsSidebar'

import Header from '@/components/Admin/Header/Header'

export default {
  name: 'SessionsAdmin',
  components: {Header, DotsHorizontalCircleOutlineIcon, CalendarBlankOutlineIcon, LocationEnterIcon, MagnifyIcon, PhoneOutgoingOutlineIcon, LoginIcon, DeleteRestoreIcon, TextBoxSearchOutlineIcon, PencilOutlineIcon, DeleteOutlineIcon, DownloadOutlineIcon, ReportAdminSidebar, EditClassroomAdminSidebar, SessionRecordingsSidebar, VideoOutlineIcon},
  mixins: [jwtMixin, utilitiesMixin],
  created () {
    this.initClassrooms()
  },
  data () {
    return {
      loading: false,
      user_groups: [],
      user_roles: [],
      classrooms: [],
      classrooms_total: 0,
      classrooms_pagination_current: 1,
      classrooms_pagination: {
        limit: this.defaultPagination(),
        offset: 0
      },
      classrooms_pagination_options: this.paginationOptions(),
      selected_filter: 'Todas las próximas sesiones',
      selected_type_filter: 'Todos los sistemas',
      selected_status_filter: 'Todos los estados',
      search_show: false,
      filter_start_date: null,
      filter_start_time: null,
      filter_end_date: null,
      filter_end_time: null,
      filter_name: null,
      waiting_filter_name: false,
      context_title: null,
      opened_search: false,
      report_sessions_csv: [],
      report_sessions_csv_labels: {
        displayName: 'Nombre de la sala',
        description: 'Descripción',
        startTime: 'Hora de inicio',
        endTime: 'Hora de finalización',
        guestUrl: 'URL de acceso para invitados',
        groups: 'Grupos'
      },
      classroomReading: null
    }
  },
  watch: {
    classrooms_pagination_current: {
      handler: function (value) {
        // CMM: se establece la paginación acorde a la página activada
        this.classrooms_pagination.offset = this.classrooms_pagination.limit * (this.classrooms_pagination_current - 1)
        this.getClassrooms()
      }
    },
    filter_name: function (val) {
      let vueComponent = this
      if (!this.waiting_filter_name) {
        setTimeout(() => {
          vueComponent.loading = true
          vueComponent.resetPagination()
          this.waiting_filter_name = false
        }, 1500)
      }
      this.waiting_filter_name = true
    }
  },
  methods: {
    initClassrooms () {
      this.loading = true

      // CMM: Por defecto en la entrada se cargan las próximas sesiones
      this.nextSessions()
    },
    getClassrooms () {
      let vueComponent = this
      this.classrooms = []
      this.classrooms_total = 0
      let filterParams = {
        limit: this.classrooms_pagination.limit,
        offset: this.classrooms_pagination.offset
      }
      // CMM: Configuración de filtros
      if (vueComponent.filter_start_date) {
        if (!this.filter_start_time) {
          this.filter_start_time = '00:00'
        }
        filterParams.startTime = window.moment(vueComponent.filter_start_date + ' ' + this.filter_start_time).utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]')
      } else {
        vueComponent.filter_start_time = null
      }
      if (vueComponent.filter_end_date) {
        if (!this.filter_end_time) {
          this.filter_end_time = '23:59'
        }
        filterParams.endTime = window.moment(vueComponent.filter_end_date + ' ' + this.filter_end_time).utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]')
      } else {
        vueComponent.filter_end_time = null
      }
      if (vueComponent.selected_type_filter) {
        if (vueComponent.selected_type_filter === 'Collaborate') {
          filterParams.targetSystem = 'COLLAB'
        } if (vueComponent.selected_type_filter === 'Adobe Connect') {
          filterParams.targetSystem = 'CONNECT'
        } if (vueComponent.selected_type_filter === 'Zoom') {
          filterParams.targetSystem = 'ZOOM'
        }
      }
      if (vueComponent.selected_status_filter) {
        if (vueComponent.selected_status_filter === 'Eliminadas') {
          filterParams.targetStatus = '0'
        } if (vueComponent.selected_status_filter === 'Activas') {
          filterParams.targetStatus = '1'
        } if (vueComponent.selected_status_filter === 'Todos los estados') {
          filterParams.targetStatus = null
        }
      }
      if (this.filter_name) {
        filterParams.name = this.filter_name
      }
      window.axios.get('classrooms/', {params: filterParams}).then((response) => {
        // CMM: Se recupera la información de las clases, sin enrollment del usuario (modo consulta)
        this.classrooms_total = response.data.size
        response.data.results.forEach(function (classroom) {
          vueComponent.classrooms.push(classroom)
        })
        this.loading = false
      })
    },
    enrollUserClassroom (classroom) {
      let vueComponent = this

      const userId = this.jwtLoggedUserId()

      let promises = []
      let enrollParams = {
        classroomId: classroom.id,
        unirGroup: classroom.unirGroups[0],
        userId: userId,
        lmsUserId: null,
        roleCode: vueComponent.jwtLoggedUserTargetSystemRole(classroom.targetSystem)
      }

      promises.push(window.axios.post('classrooms/' + classroom.id + '/enrollments/', enrollParams).then((response) => {
        classroom.enrollment = response.data
        if (classroom && classroom.enrollment && classroom.enrollment.launchUrl) {
          vueComponent.launchUrl(classroom.enrollment.launchUrl, '_blank')
        }
      }))
    },
    launchPhoneCall (phoneNumber) {
      window.open('tel:' + phoneNumber, '_self')
    },
    resetPagination () {
      // CMM: Si no estaba en la páginia inicial se cambia a la primera. El cambio lanza la recarga del listado
      if (this.classrooms_pagination_current !== 1) {
        this.classrooms_pagination_current = 1
      } else {
        this.getClassrooms()
      }
    },
    nextSessions () {
      this.selected_filter = 'Todas las próximas sesiones'
      this.filter_start_date = window.moment().format('YYYY-MM-DD')
      this.filter_start_time = window.moment().format('HH:mm')
      this.filter_end_date = null
      this.filter_end_time = null
      this.resetPagination()
    },
    pastSessions () {
      this.selected_filter = 'Todas las sesiones anteriores'
      this.filter_start_date = null
      this.filter_start_time = null
      this.filter_end_date = window.moment().format('YYYY-MM-DD')
      this.filter_end_time = window.moment().format('HH:mm')
      this.resetPagination()
    },
    intervalSessions () {
      this.selected_filter = 'Sesiones en el intervalo'
      this.filter_start_date = window.moment().format('YYYY-MM-DD')
      this.filter_start_time = '00:00'
      this.filter_end_date = window.moment().format('YYYY-MM-DD')
      this.filter_end_time = '23:59'
      this.resetPagination()
    },
    typeSessions (type) {
      this.selected_type_filter = type
      this.resetPagination()
    },
    typeStatus (type) {
      this.selected_status_filter = type
      this.resetPagination()
    },
    dispatchShowReportEvent (classroomId) {
      window.EventBus.$emit('show-report', classroomId)
    },
    launchUrl (url, target) {
      window.open(url, target)
    },
    getUnique (arr, comp) {
      const unique = arr.map(e => e[comp])
        .map((e, i, final) => final.indexOf(e) === i && i)
        .filter((e) => arr[e]).map(e => arr[e])
      return unique
    },
    csvClassrooms () {
      let vueComponent = this
      this.report_sessions_csv = []
      let filterParams = {}
      // CMM: Configuración de filtros, sin límite de paginacion en la descarga del CSV
      if (vueComponent.filter_start_date) {
        filterParams.startTime = window.moment(vueComponent.filter_start_date + ' ' + this.filter_start_time).utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]')
      }
      if (vueComponent.filter_end_date) {
        filterParams.endTime = window.moment(vueComponent.filter_end_date + ' ' + this.filter_end_time).utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]')
      }
      if (vueComponent.selected_type_filter) {
        if (vueComponent.selected_type_filter === 'Collaborate') {
          filterParams.targetSystem = 'COLLAB'
        } else if (vueComponent.selected_type_filter === 'Adobe Connect') {
          filterParams.targetSystem = 'CONNECT'
        }
      }
      if (this.filter_name) {
        filterParams.name = this.filter_name
      }
      window.axios.get('classrooms/', {params: filterParams}).then((response) => {
        // CMM: Se recupera la información de las clases, sin enrollment del usuario (modo consulta)
        this.classrooms_total = response.data.size
        response.data.results.forEach(function (classroom) {
          // CMM: Se compone el registro para la exportación a CSV
          let csvSession = {
            displayName: classroom.name,
            description: classroom.description,
            startTime: classroom.start ? window.moment(classroom.start).format('YYYY-MM-DD HH:mm:ss') : null,
            lastLeave: classroom.end ? window.moment(classroom.end).format('YYYY-MM-DD HH:mm:ss') : null,
            guestUrl: classroom.guestUrl ? classroom.guestUrl : null,
            groups: classroom.unirGroups ? classroom.unirGroups.join(',') : null
          }
          vueComponent.report_sessions_csv.push(csvSession)
        })
        console.log(this.$refs.reportSessionDownload)
        this.$refs.reportSessionDownload.$el.click()
      })
    },
    confirmDelete (classroom) {
      let vueComponent = this
      this.$confirm(
        {
          title: `Eliminar sesión`,
          message: `Esta sesión se eliminará. ¿Estás seguro de que deseas continuar?`,
          button: {
            no: 'No, cancelar',
            yes: 'Si, eliminar'
          },
          callback: confirm => {
            if (confirm) {
              // CMM: Se elimina la sesión
              window.axios.delete('classrooms/' + classroom.id).then((response) => {
                if (response && response.status === 200) {
                  vueComponent.$noty.success('La sesión se ha eliminado correctamente', {
                    timeout: 3000,
                    progressBar: true
                  })
                  this.getClassrooms()
                }
              })
            }
          }
        }
      )
    },
    confirmRecover (classroom) {
      let vueComponent = this
      this.$confirm(
        {
          title: `Restaurar sesión`,
          message: `Esta sesión se restaurara. ¿Estás seguro de que deseas continuar?`,
          button: {
            no: 'No, cancelar',
            yes: 'Si, restaurar'
          },
          callback: confirm => {
            if (confirm) {
              // CMM: Se elimina la sesión
              window.axios.put('classrooms/restore/' + classroom.id).then((response) => {
                if (response && response.status === 200) {
                  vueComponent.$noty.success('La sesión se ha restaurado correctamente', {
                    timeout: 3000,
                    progressBar: true
                  })
                  this.getClassrooms()
                }
              })
            }
          }
        }
      )
    },
    openRecordings (classroom) {
      let vueComponent = this
      vueComponent.classroomReading = classroom
    },
    hideSearch () {
      this.search_show = false
      this.waiting_filter_name = false
      this.opened_search = false
    },
    showSearch () {
      this.search_show = true
      this.opened_search = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/SessionsAdmin.vue